import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { toast } from 'sonner';
import { useRenameFlow } from '@/hooks/vsl-dinamica/useDynamicFlows';
import type { FlowListItem } from '@/services/dynamicFlowsService';
import { FlowNameDialog } from './FlowNameDialog';

interface RenameFlowDialogProps {
  flow: FlowListItem | null;
  onOpenChange: (open: boolean) => void;
}

export function RenameFlowDialog({ flow, onOpenChange }: RenameFlowDialogProps) {
  useLanguage();
  const renameFlow = useRenameFlow();

  const rename = async (name: string) => {
    if (!flow) return;
    try {
      await renameFlow.mutateAsync({ id: flow.id, name });
      toast.success(translateInterfaceText("Fluxo renomeado."));
      onOpenChange(false);
    } catch (error) {
      toast.error((error as Error).message || translateInterfaceText("Não foi possível renomear o fluxo."));
    }
  };

  return (
    <FlowNameDialog
      open={!!flow}
      onOpenChange={onOpenChange}
      title={translateInterfaceText("Renomear fluxo")}
      submitLabel={translateInterfaceText("Salvar nome")}
      initialName={flow?.name || ''}
      pending={renameFlow.isPending}
      onSubmit={rename}
    />
  );
}
